// Shared expand/collapse motion for the icon rail — used by IconRail and its
// child rows (e.g. ThemeToggle) so the width slide, every label wipe and every
// fade move as one motion on the same curve.

// The one curve everything on the rail animates with.
export const RAIL_EASE = 'motion-safe:ease-[cubic-bezier(0.32,0.72,0,1)]';

/** Shared label reveal for every rail row (nav item, logo, toggle, theme,
 *  account): a max-width wipe + opacity fade on {@link RAIL_EASE}, so labels
 *  glide in and out with the panel instead of popping. `hidden md:block` keeps
 *  the mobile top-bar icon-only; the inner `pl-2` is the icon→label gap and is
 *  clipped to nothing while collapsed (max-w-0 + overflow-hidden), so it never
 *  widens the collapsed rail. */
export function labelReveal(expanded: boolean) {
  return `hidden overflow-hidden whitespace-nowrap md:block motion-safe:transition-[max-width,opacity] motion-safe:duration-300 ${RAIL_EASE} ${
    expanded ? 'max-w-[9rem] pl-2 opacity-100' : 'max-w-0 opacity-0'
  }`;
}
